import type {
  SearchUserAppRoleViewQuery,
  SearchUsersContentVisibilityQuery,
  SearchUsersByAppRoleFiltersQuery,
} from '@exam-management/graphql';

import type { UserStatus } from '../..';
import type { UserRow } from '../../user-list/types';

export function mapUserList(
  users?: SearchUsersByAppRoleFiltersQuery['UsBoSearchUsersWithAppRoleFilters']['users'],
): UserRow[] {
  if (!users) return [];
  const mappedArray = users.map((user) => {
    const mapped: UserRow = {
      profile: {
        firstName: user.firstname,
        lastName: user.lastname,
        email: user.email ?? '-',
        profilePic: '',
      },
      userId: user.id,
      appRoles: (user.appRoles ?? []) as string[],
      status: (user.status ?? '-') as UserStatus,
      lastLoginAt: user.lastLoginAt ?? '',
      invitationExpireAt: user.invitationExpireAt,
    };
    return mapped;
  });

  return mappedArray;
}

export function mapApoRolesUserList(
  users: SearchUserAppRoleViewQuery['getUserAppRoleView']['users'],
): Omit<UserRow, 'appRoles'>[] {
  const mappedArray = users.map((user) => {
    const mapped: Omit<UserRow, 'appRoles'> = {
      profile: {
        firstName: user.firstname,
        lastName: user.lastname,
        email: user.email ?? '-',
        profilePic: '',
      },
      userId: user.id,
      status: (user.status ?? '-') as UserStatus,
      lastLoginAt: user.lastLoginAt ?? '',
      invitationExpireAt: user.invitationExpireAt,
    };
    return mapped;
  });
  return mappedArray;
}

export function mapQBankStructureMemberList(
  users: SearchUsersContentVisibilityQuery['cvSearchUsersContentVisibility']['users'],
): Omit<UserRow, 'lastLoginAt'>[] {
  const mappedArray = users.map((user) => {
    const mapped: Omit<UserRow, 'lastLoginAt'> = {
      profile: {
        firstName: user.firstname,
        lastName: user.lastname,
        email: user.email ?? '-',
        profilePic: user.image ?? '',
      },
      userId: user.id,
      appRoles: (user.appRoles ?? []) as string[],
      status: (user.status ?? '-') as UserStatus,
      invitationExpireAt: user.invitationExpireAt,
    };
    return mapped;
  });
  return mappedArray;
}
